import { Panel, Skeleton, Stack, tokens } from '@cast/design-system';

export const ServiceHealthTileSkeleton = () => (
  <Panel
    sx={{
      p: 16,
      minWidth: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      border: '1px solid',
      borderColor: tokens.theme.border.structural.neutral,
    }}
  >
    <Stack gap={8} sx={{ width: '100%' }}>
      <Skeleton variant="text" width="60%" height={18} />
      <Skeleton variant="rounded" width={72} height={28} />
    </Stack>
  </Panel>
);
